export const LIB_VERSION = '1.283.0'; // autogenerated
